import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeFieldsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const fieldsSelector = makeFieldsSelector();
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      alert: localState.alert,
      error: localState.error,

      fields: fieldsSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
